'use client';

import { FC } from 'react';

import { Button, Modal } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { NAVIGATION_MODAL_ZINDEX } from '@telialt/common-constants/src/modal';

import { PLAN_CARD_TEST_ID } from '../constants';
import { useDetailsModalControls } from '../hooks/useDetailsModalControls';
import { PlanCardModel } from '../model';

export const DetailsModal: FC<{ details: PlanCardModel.Detail[] }> = ({ details }) => {
    const { isDetailsModalOpen, closeDetailsModal, id, modalTitle } = useDetailsModalControls();
    const { t } = useTranslations();
    const detail = details?.find((d) => d.id === id);
    const modal = detail?.modal;

    return (
        <Modal open={isDetailsModalOpen} onOpenChange={(open) => !open && closeDetailsModal()}>
            <Modal.Content
                title={modalTitle || detail?.text}
                actions={
                    <Button variant="primary" onClick={() => closeDetailsModal()}>
                        {t['common.button.close']}
                    </Button>
                }
                stickyButtons={true}
                image={
                    !!modal?.imageUrl && (
                        <img
                            src={modal.imageUrl}
                            alt={modal.imageAlt}
                            role={!modal.imageAlt ? 'presentation' : undefined}
                        />
                    )
                }
                closeButtonAriaLabel={t['common.button.close']}
                showCloseButton={true}
                zIndex={NAVIGATION_MODAL_ZINDEX}
                data-test={PLAN_CARD_TEST_ID.DETAILS_MODAL}
            >
                {modal?.content}
            </Modal.Content>
        </Modal>
    );
};
